<div fxFlexAlign="center" fxLayout="column" fxLayoutAlign="center center" class="text-center"
     ngClass.desktop="pl-56 pr-56 pt-48 pb-48 shadow-content" ngClass.mobile="pt-24 pl-16 pr-16 w-100 mt-80">
</div>
